module.exports = __webpack_public_path__ + "static/media/skills.c7ba2e62.svg";